<div *ngIf="!isLoading">
  <ng-container *ngFor="let details of sectionWiseService.sectionDetailsModel">
    <single-section [sectionDetails]="details" [contractType]="contractType"></single-section>
  </ng-container>
</div>
